import {
  SIDE_NAV_LIGHT,
  // NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "../env";

export const APP_NAME = "Customer Portal";
export const COMPANY_NAME = "Air Culinaire Worldwide";
export const API_BASE_URL = env.REACT_APP_DATA_MANAGEMENT_PAPI_URL;
export const SHIPDAY_API_BASE_URL = env.SHIPDAY_API_BASE_URL;
export const SEARCH_INDEX_BASE_URL = env.REACT_APP_SEARCH_INDEX_BASE_URL;
export const ORDERS_INDEX = env.REACT_APP_ORDERS_INDEX;
export const SEARCH_INDEX_API_KEY = env.REACT_APP_SEARCH_INDEX_API_KEY;
export const SEARCH_FACETS = env.REACT_APP_SEARCH_FACETS;
export const PARTNER_API_BASE = env.REACT_APP_PARTNERS_PAPI;
export const PORTAL_API_BASE = env.REACT_APP_PORTAL_API;
export const WEBSOCKET_URL = env.REACT_APP_WEBSOCKET_URL;
export const CP_UAM_SUBSCRIPTION_KEY = env.REACT_APP_CP_UAM_SUBSCRIPTION_KEY;
export const PARTNER_API_CLIENT_ID = env.REACT_APP_OKTA_CLIENT_ID;
export const PARTNER_API_CLIENT_SECRET = env.REACT_APP_OKTA_CLIENT_SECRET;
export const DOCUMENT_BLOB_SHA = env.REACT_APP_DOCUMENT_SHA;
export const BC_LANDING = env.REACT_APP_BC_LANDING;
export const OKTA_SCOPES =
  "openid profile email permission approle groups customer_party_ids";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = `/auth`;
export const PUBLIC_PREFIX_PATH = `/public`;
export const REDIRECT_URL_KEY = "redirect";
// export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/orders`;
export const VENDOR_AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/vendor/orders`;
export const KITCHEN_AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/kitchen/index`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const D365_URL = env.REACT_APP_D365_URL;
export const SALES_TABLE = env.REACT_APP_SALES_TABLE;
export const OKTA_GROUP_PREFIX = env.REACT_APP_OKTA_GROUP_PREFIX;
export const OKTA_ADMIN_GROUP = env.REACT_APP_OKTA_ADMIN_GROUP;
export const CATERING_API_BASE_URL = env.REACT_APP_CATERING_API;
export const CATERING_API_CLIENT_ID = env.REACT_APP_CATERIG_CLIENT_ID;
export const CATERING_API_CLIENT_SECRET = env.REACT_APP_CATERING_CLIENT_SECRET;
export const KITCHEN_POWERBI_REPORT = env.REACT_APP_KITCHEN_POWERBI_REPORT;
export const SEND_EMAIL_AZURE_FUNCTION_URL =
  env.REACT_APP_EMAIL_AZURE_FUNCTION_URL;
export const EMAIL_OPERATOR_CREATED_TEMPLATE =
  env.REACT_APP_EMAIL_OPERATOR_CREATED_TEMPLATE;
export const SELF_SERVICE_EMAIL_OPERATOR_CREATED_TEMPLATE =
  env.REACT_APP_SELF_SERVICE_EMAIL_OPERATOR_CREATED_TEMPLATE;
export const EMAIL_SERVICE_FROM_EMAIL = env.REACT_APP_EMAIL_SERVICE_FROM_EMAIL;
export const ALLOW_DISPOSABLE =
  env.REACT_APP_ALLOW_DISPOSABLE_EMAILS === "true";
export const ACCOUNT_CREATION_INTERNAL_EMAIL =
  env.REACT_APP_ACCOUNT_CREATION_INTERNAL_EMAIL;
export const INTERNAL_EMAIL_OPERATOR_CREATED_TEMPLATE =
  env.REACT_APP_INTERNAL_EMAIL_OPERATOR_CREATED_TEMPLATE;

export const THEME_CONFIG = {
  navCollapsed: true,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_TOP,
  topNavColor: "",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
